module.exports = __webpack_public_path__ + "img/top2.70198606.png";